module.exports = __webpack_public_path__ + "img/logo.b8f2ab2f.png";